(function () {
  patchFetch();

  var notice = document.querySelector(".add-to-cart-notice:not([data-bound='true'])");
  if (!notice) return;

  var HIDE_MS = 5000;
  var hideTimer = 0;
  var hideResetTimer = 0;
  var showToken = 0;
  var frameToken = 0;
  var scrollTick = false;
  var leftovers = document.querySelectorAll(".add-to-cart-notice");
  var sectionEl = notice.closest(".shopify-section");
  var i;

  notice.dataset.bound = "true";
  for (i = 0; i < leftovers.length; i += 1) {
    if (leftovers[i] !== notice) leftovers[i].remove();
  }
  document.body.appendChild(notice);
  if (sectionEl) sectionEl.hidden = true;

  window.showNotice = function (type, payload) {
    if (type === "error") {
      openNotice("error", typeof payload === "string" ? payload : "");
      return;
    }
    present(readTask(type, payload));
  };
  window.hideNotice = hideNotice;

  notice.addEventListener("mouseenter", function () {
    clearTimeout(hideTimer);
  });
  notice.addEventListener("mouseleave", function () {
    if (!notice.classList.contains("is-visible")) return;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideNotice, HIDE_MS);
  });
  var closeButton = notice.querySelector(".notice_button_close");
  var viewCart = notice.querySelector(".notice_button_view_cart");
  if (closeButton) closeButton.addEventListener("click", hideNotice);
  if (viewCart) {
    viewCart.addEventListener("click", function (event) {
      if (viewCart.getAttribute("data-leaving") === "true") return;
      event.preventDefault();
      viewCart.setAttribute("data-leaving", "true");
      hideNotice();
      window.setTimeout(function () {
        window.location.href = viewCart.href;
      }, 360);
    });
  }
  document.addEventListener("click", function (event) {
    if (!notice.classList.contains("is-visible") || notice.contains(event.target)) return;
    hideNotice();
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && notice.classList.contains("is-open")) hideNotice();
  });
  window.addEventListener("pagehide", resetNotice);
  window.addEventListener("pageshow", function (event) {
    if (event.persisted || notice.classList.contains("is-open")) resetNotice();
  });
  window.addEventListener("resize", function () {
    if (notice.classList.contains("is-open")) placeNotice();
  });
  window.addEventListener("scroll", function () {
    if (!notice.classList.contains("is-open") || scrollTick) return;
    scrollTick = true;
    window.requestAnimationFrame(function () {
      scrollTick = false;
      if (notice.classList.contains("is-open")) placeNotice();
    });
  }, { passive: true });

  function readTask(type, payload) {
    var direct = null;
    if (Array.isArray(type)) direct = type;
    else if (Array.isArray(payload)) direct = payload;
    else if (payload && Array.isArray(payload.items)) direct = payload.items;
    if (direct) return Promise.resolve(normalizeList(direct, []));
    return window.__atcAddedItemsPromise || Promise.resolve(window.__atcAddedItems || []);
  }

  function present(task) {
    var token = ++showToken;
    clearTimeout(hideTimer);
    Promise.resolve(task).then(function (items) {
      if (token !== showToken) return;
      renderItems(items || []);
      openNotice("success");
      trackToastView(items || []);
    }).catch(function () {
      if (token !== showToken) return;
      renderItems([]);
      openNotice("success");
    });
  }

  function trackToastView(items) {
    if (!items || !items.length) return;
    window.dataLayer = window.dataLayer || [];
    items.forEach(function (item) {
      window.dataLayer.push({
        event: "add_to_cart_toast_view",
        product_id: item.product_id || "",
        variant_id: item.variant_id || "",
        item_name: item.title || "",
        quantity: item.quantity || 1
      });
    });
  }

  function openNotice(mode, errorText) {
    var frame = ++frameToken;
    if (mode === "error") showToken += 1;
    clearTimeout(hideResetTimer);
    setMode(mode, errorText);
    notice.classList.add("is-open");
    notice.classList.remove("is-visible", "is-closing");
    notice.setAttribute("aria-hidden", "false");
    placeNotice();
    window.requestAnimationFrame(function () {
      if (frame !== frameToken) return;
      notice.classList.add("is-visible");
    });
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideNotice, HIDE_MS);
  }

  function hideNotice() {
    if (!notice.classList.contains("is-open") || notice.classList.contains("is-closing")) return;
    frameToken += 1;
    clearTimeout(hideTimer);
    clearTimeout(hideResetTimer);
    notice.classList.add("is-closing");
    notice.setAttribute("aria-hidden", "true");
    window.requestAnimationFrame(function () {
      notice.classList.remove("is-visible");
    });
    hideResetTimer = setTimeout(function () {
      if (!notice.classList.contains("is-visible")) {
        notice.classList.remove("is-open", "is-closing");
      }
    }, 340);
  }

  function resetNotice() {
    frameToken += 1;
    showToken += 1;
    clearTimeout(hideTimer);
    clearTimeout(hideResetTimer);
    notice.classList.remove("is-visible", "is-open");
    notice.setAttribute("aria-hidden", "true");
  }

  function setMode(mode, errorText) {
    var isError = mode === "error";
    var errorEl = notice.querySelector(".notice_message_error");
    var successEl = notice.querySelector(".notice_message_success");
    var errorIcon = notice.querySelector(".error_noitce");
    var viewCart = notice.querySelector(".notice_button_view_cart");
    var items = notice.querySelector(".add-to-cart-notice__items");
    notice.classList.toggle("is-error", isError);
    notice.classList.toggle("is-success", !isError);
    notice.style.setProperty("--atc-arrow", isError ? notice.dataset.errorBg : notice.dataset.successBg);
    if (errorIcon) errorIcon.hidden = !isError;
    if (successEl) successEl.hidden = isError;
    if (errorEl) {
      errorEl.hidden = !isError;
      if (isError) errorEl.textContent = errorText || notice.dataset.errorText || "";
    }
    if (viewCart) viewCart.hidden = isError;
    if (items) items.hidden = isError || items.children.length === 0;
  }

  function renderItems(items) {
    var list = notice.querySelector(".add-to-cart-notice__items");
    if (!list) return;
    list.textContent = "";
    items.forEach(function (item) {
      var row = document.createElement("li");
      var img = document.createElement("img");
      var name = document.createElement("p");
      var qty = document.createElement("span");
      row.className = "add-to-cart-notice__item";
      img.className = "add-to-cart-notice__image";
      img.alt = "";
      img.width = 44;
      img.height = 44;
      if (item.image) img.src = item.image;
      img.addEventListener("error", function () {
        if (img.getAttribute("data-broken") === "true") return;
        img.setAttribute("data-broken", "true");
        img.removeAttribute("src");
      });
      name.className = "add-to-cart-notice__name";
      name.textContent = item.title || "";
      name.title = item.title || "";
      qty.className = "add-to-cart-notice__qty";
      qty.textContent = "x" + (item.quantity || 1);
      row.appendChild(img);
      row.appendChild(name);
      row.appendChild(qty);
      list.appendChild(row);
    });
    list.hidden = items.length === 0;
  }

  function placeNotice() {
    var anchor = getCartAnchor();
    var margin = 8;
    var side = margin;
    var width = notice.offsetWidth;
    var top = 72;
    var left = Math.max(margin, window.innerWidth - margin - width);
    var arrowLeft = Math.max(12, width - 36);
    var arrow = notice.querySelector(".add-to-cart-notice__arrow");
    var rect = null;
    var maxLeft;
    var available;

    if (anchor) {
      rect = anchor.getBoundingClientRect();
      top = Math.round(rect.bottom + 8);
      left = Math.round(rect.right - width);
    }
    if (window.matchMedia("(max-width: 768px)").matches) {
      side = 16;
      left = Math.round(contentRightEdge() - side - width);
    }
    if (left < side) left = side;
    maxLeft = window.innerWidth - side - width;
    if (left > maxLeft) left = Math.max(side, maxLeft);
    if (top < margin) top = margin;
    available = window.innerHeight - top - margin;
    if (available < 140) {
      top = Math.max(margin, window.innerHeight - margin - 140);
      available = window.innerHeight - top - margin;
    }
    if (rect) arrowLeft = rect.left + rect.width / 2 - left - 6;
    arrowLeft = Math.max(8, Math.min(Math.max(width - 16, 8), arrowLeft));
    notice.style.top = top + "px";
    notice.style.left = left + "px";
    notice.style.right = "auto";
    notice.style.maxHeight = Math.max(available, 0) + "px";
    if (arrow) {
      arrow.style.left = arrowLeft + "px";
      arrow.style.right = "auto";
    }
  }

  function contentRightEdge() {
    var shell = document.querySelector(".header-v3-wrapper");
    if (!shell) return window.innerWidth;
    return shell.getBoundingClientRect().right;
  }

  function getCartAnchor() {
    var selectors = [
      ".header-v3-icon[aria-label='Cart']",
      ".PC_TopNav_Cart",
      ".Mobile_TopNav_Cart",
      "a[aria-controls='mini-cart']"
    ];
    var s;
    var nodes;
    var n;
    var rect;
    for (s = 0; s < selectors.length; s += 1) {
      nodes = document.querySelectorAll(selectors[s]);
      for (n = 0; n < nodes.length; n += 1) {
        rect = nodes[n].getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return nodes[n];
      }
    }
    return null;
  }

  function patchFetch() {
    if (window.__atcFetchPatched || typeof window.fetch !== "function") return;
    window.__atcFetchPatched = true;
    var nativeFetch = window.fetch;

    window.fetch = function (input, init) {
      var pending = nativeFetch.apply(this, arguments);
      if (requestUrl(input).indexOf("/cart/add") === -1) return pending;

      var requestItems = readRequestItems(init);
      return pending.then(function (response) {
        if (response && response.ok) captureAddedItems(response, requestItems);
        return response;
      });
    };
  }

  function captureAddedItems(response, requestItems) {
    try {
      window.__atcAddedItemsPromise = response.clone().json().then(function (data) {
        var items = normalizeList(listFromAdd(data), requestItems);
        window.__atcAddedItems = items;
        return items;
      }).catch(function () {
        return window.__atcAddedItems || [];
      });
    } catch (error) {
      window.__atcAddedItemsPromise = Promise.resolve(window.__atcAddedItems || []);
    }
  }

  function requestUrl(input) {
    if (typeof input === "string") return input;
    if (input && typeof input.url === "string") return input.url;
    return "";
  }

  function readRequestItems(init) {
    if (!init || init.body == null) return [];
    var body = init.body;
    if (typeof body === "string") {
      try {
        var data = JSON.parse(body);
        if (Array.isArray(data.items)) return data.items;
        if (data.id) return [{ id: data.id, quantity: data.quantity || 1 }];
      } catch (error) {
        var params = new URLSearchParams(body);
        if (params.get("id")) return [{ id: params.get("id"), quantity: params.get("quantity") || 1 }];
      }
      return [];
    }
    if (typeof FormData !== "undefined" && body instanceof FormData && body.get("id")) {
      return [{ id: body.get("id"), quantity: body.get("quantity") || 1 }];
    }
    return [];
  }

  function listFromAdd(data) {
    if (!data) return [];
    if (Array.isArray(data.items)) return data.items;
    if (data.product_title || data.title) return [data];
    return [];
  }

  function normalizeList(list, requestItems) {
    return (list || []).map(function (item, index) {
      if (!item) return null;
      if (item.__atc) return item;
      if (item.title && !item.product_title && !item.featured_image && !item.variant_id) {
        return {
          __atc: true,
          title: item.title,
          quantity: positiveQty(item.quantity),
          image: typeof item.image === "string" ? item.image : "",
          product_id: item.product_id || "",
          variant_id: item.variant_id || item.id || ""
        };
      }
      var matched = findRequest(requestItems, item.variant_id || item.id);
      if (!matched && requestItems && requestItems.length === list.length) {
        matched = requestItems[index] || null;
      }
      return {
        __atc: true,
        title: item.product_title || item.title || "",
        quantity: positiveQty(matched && matched.quantity ? matched.quantity : item.quantity),
        image: imageUrl(item),
        product_id: item.product_id || "",
        variant_id: item.variant_id || item.id || (matched && matched.id) || ""
      };
    }).filter(function (item) {
      return item && item.title;
    });
  }

  function findRequest(requestItems, variantId) {
    var i;
    var requestItem;
    if (!requestItems || !requestItems.length) return null;
    for (i = 0; i < requestItems.length; i += 1) {
      requestItem = requestItems[i];
      if (!requestItem || requestItem.id == null) continue;
      if (String(requestItem.id) === String(variantId)) return requestItem;
    }
    return null;
  }

  function positiveQty(value) {
    var qty = Number(value);
    return qty > 0 ? qty : 1;
  }

  function imageUrl(item) {
    var image = "";
    if (!item) return image;
    if (typeof item.image === "string") image = item.image;
    else if (item.image) image = item.image.src || item.image.url || "";
    if (!image && typeof item.featured_image === "string") image = item.featured_image;
    else if (!image && item.featured_image) image = item.featured_image.url || item.featured_image.src || "";
    if (image.indexOf("//") === 0) image = "https:" + image;
    if (image && image.indexOf("width=") === -1) {
      image += (image.indexOf("?") === -1 ? "?" : "&") + "width=160";
    }
    return image;
  }
})();
